import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { BANNER_CACHE_KEYS } from "./keys";

import { BannerRepository } from "@/repositories/banner";

export const useDeleteBanner = () => {
  const queryClient = useQueryClient();
  const bannerRepository = useRef(new BannerRepository());

  return useMutation({
    mutationFn: (id: string) => bannerRepository.current.delete(id),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: BANNER_CACHE_KEYS.LIST }),
  });
};
